export default __webpack_public_path__ + "static/media/properties.31560185.txt";